var CULTURAL = function(strictLocalize) {
    return {
        title: strictLocalize({
            id: "si65r+",
            defaultMessage: [
                {
                    type: 0,
                    value: "Cultural programming"
                }
            ]
        }),
        description: strictLocalize({
            id: "xLi3+N",
            defaultMessage: [
                {
                    type: 0,
                    value: "We celebrate cultural moments throughout the year with programming centered on education, celebration, and introspection to help further connect our employees."
                }
            ]
        }),
        number: "01"
    };
};
var TRANSPARENCY = function(strictLocalize) {
    return {
        title: strictLocalize({
            id: "4qYEBS",
            defaultMessage: [
                {
                    type: 0,
                    value: "Transparency for all"
                }
            ]
        }),
        description: strictLocalize({
            id: "FDqwWO",
            defaultMessage: [
                {
                    type: 0,
                    value: "We want all our employees to feel seen and heard. We frequently report findings from our engagement surveys and focus group listening sessions to hold ourselves accountable for improving our employee experience."
                }
            ]
        }),
        number: "02"
    };
};
var HIRING = function(strictLocalize) {
    return {
        title: strictLocalize({
            id: "SEpGeg",
            defaultMessage: [
                {
                    type: 0,
                    value: "Hiring & retention processes"
                }
            ]
        }),
        description: strictLocalize({
            id: "oSN6t4",
            defaultMessage: [
                {
                    type: 0,
                    value: "We collect aggregate voluntary demographic data and conduct regular audits of our global talent practices to ensure our processes are fair and equitable."
                }
            ]
        }),
        number: "03"
    };
};
var EMPLOYEE = function(strictLocalize) {
    return {
        title: strictLocalize({
            id: "o4Hwyn",
            defaultMessage: [
                {
                    type: 0,
                    value: "Employee development"
                }
            ]
        }),
        description: strictLocalize({
            id: "VBD2K7",
            defaultMessage: [
                {
                    type: 0,
                    value: "We ensure all employees have equitable opportunities for personal and professional growth by providing tools, resources, and workshops on topics like microaggressions, pay equity, and imposter syndrome. We also train all of our leaders to support and grow inclusive teams."
                }
            ]
        }),
        number: "04"
    };
};
export var FAIRE_ACTIONS = function(strictLocalize) {
    return [
        CULTURAL(strictLocalize),
        TRANSPARENCY(strictLocalize),
        HIRING(strictLocalize),
        EMPLOYEE(strictLocalize)
    ];
};
